<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from 'svelte';
    import { onDestroy } from 'svelte';
    import { fade, slide } from 'svelte/transition';

    export let show = false;

    const dispatch = createEventDispatcher();
    const AUTOPLAY_MS = 4500;

    const products = [
        {
            name: 'ReturnoAI',
            description: 'ניהול חכם של החזרות והחלפות עם אוטומציה מלאה לתהליך השירות.',
            link: 'https://apps.shopify.com/returnoai',
            linkLabel: 'לאפליקציה ב-Shopify',
            icon: '/images/returnoai.png'
        },
        {
            name: 'Retailo',
            description: 'פתרון לניהול פעילות קמעונאית ומעקב הזמנות בצורה פשוטה ויעילה.',
            icon: '/images/retailo.png',
            hidden: true
        },
        {
            name: 'SUPERPHARM BOT',
            description: 'בוט לאוטומציה של מחירים מול מתחרים ועדכון מהיר של נתוני שוק.',
            icon: '/images/superpharm.png'
        },
        {
            name: 'Mullino',
            description: 'מערכת דיוור עם אוטומציות ב-SMS, Email ו-WhatsApp, כולל רשימות תפוצה, פופאפים באתר וניהול רשימות תפוצה.',
            icon: '/images/returnoai.png'
        },
        {
            name: 'Visual AI',
            description: 'יצירת תמונות מוצרים, הדמיות וסרטוני מוצר מותאמים לאתרי מסחר להגדלת המרות ומכירות. אין יותר ימי צילום - יותר הפקות מטורפות, הכל אוטומטי.',
            icon: '/images/returnoai.png'
        }
    ];

    let currentIndex = 0;
    let autoSlideTimer = null;

    function closePromo() {
        dispatch('close');
    }

    function promoSummary(product) {
        const text = (product.description || '').toString().trim();
        if (text.length <= 85) {
            return text;
        }

        return `${text.slice(0, 82)}...`;
    }

    function startAutoSlide() {
        stopAutoSlide();
        autoSlideTimer = setInterval(() => {
            goNext();
        }, AUTOPLAY_MS);
    }

    function stopAutoSlide() {
        if (autoSlideTimer) {
            clearInterval(autoSlideTimer);
            autoSlideTimer = null;
        }
    }

    function goTo(index) {
        if (!visibleProducts.length) {
            return;
        }

        const max = visibleProducts.length;
        currentIndex = ((index % max) + max) % max;

        if (show && max > 1) {
            startAutoSlide();
        }
    }

    function goNext() {
        goTo(currentIndex + 1);
    }

    function goPrev() {
        goTo(currentIndex - 1);
    }

    $: visibleProducts = products.filter((product) => !product.hidden);
    $: currentProduct = visibleProducts[currentIndex] || null;

    $: if (visibleProducts.length && currentIndex > visibleProducts.length - 1) {
        currentIndex = 0;
    }

    $: {
        if (show && visibleProducts.length > 1) {
            startAutoSlide();
        } else {
            stopAutoSlide();
        }
    }

    onDestroy(() => {
        stopAutoSlide();
    });
</script>

{#if show}
    <section class="returno-top-banner" transition:slide>
        <div class="returno-top-carousel" aria-label="Products carousel">
            <button type="button" class="returno-nav" on:click={goPrev} aria-label="Previous product">&#10094;</button>

            <div class="returno-slide-wrap">
                {#if currentProduct}
                    {#key currentProduct.name}
                        <div class="returno-top-item" in:fade={{ duration: 220 }} out:fade={{ duration: 160 }}>
                            <img src={currentProduct.icon} alt={currentProduct.name} class="returno-top-item-icon" />
                            <div class="returno-top-item-content">
                                <strong>{currentProduct.name}</strong>
                                <span>{promoSummary(currentProduct)}</span>
                                {#if currentProduct.link}
                                    <a
                                        href={currentProduct.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {currentProduct.linkLabel}
                                    </a>
                                {/if}
                            </div>
                        </div>
                    {/key}
                {/if}
            </div>

            <button type="button" class="returno-nav" on:click={goNext} aria-label="Next product">&#10095;</button>
        </div>

        <div class="returno-top-contact">
            יצירת קשר: 0545445278 
            <!-- |
             <a href="mailto:tal@datalogics.co.il">tal@datalogics.co.il</a> -->
        </div>

        <div class="returno-top-actions">
            <button class="returno-top-close" on:click={closePromo}>
                {$_('returnoai.close')}
            </button>
        </div>
    </section>
{/if}

<style>
    .returno-top-banner {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-right: 0;
        min-height: 38px;
        padding: 4px 8px;
        box-sizing: border-box;
        background: #ffffff;
        color: #111111;
        border-radius: 8px;
        overflow: hidden;
    }

    .returno-top-carousel {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .returno-slide-wrap {
        flex: 1;
        min-width: 0;
        overflow: hidden;
    }

    .returno-top-item {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }

    .returno-top-item-icon {
        height: 22px;
        border-radius: 6px;
        object-fit: cover;
        flex-shrink: 0;
    }

    .returno-top-item-content {
        display: flex;
        align-items: baseline;
        gap: 5px;
        font-size: 12px;
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
    }

    .returno-top-item-content strong {
        font-size: 12px;
        color: #111111;
        flex-shrink: 0;
    }

    .returno-top-item-content span {
        color: #374151;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .returno-top-item-content a {
        color: #111111;
        text-decoration: underline;
        font-weight: 700;
        flex-shrink: 0;
    }

    .returno-nav {
        width: 22px;
        height: 22px;
        border: 1px solid #d1d5db;
        background: #f9fafb;
        border-radius: 999px;
        color: #111111;
        line-height: 1;
        font-size: 11px;
        cursor: pointer;
        flex-shrink: 0;
        padding: 0;
    }

    .returno-top-contact {
        color: #374151;
        font-size: 11px;
        white-space: nowrap;
    }

    .returno-top-contact {
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .returno-top-actions {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .returno-top-close {
        border: 1px solid #111111;
        background: #111111;
        color: #ffffff;
        border-radius: 999px;
        padding: 2px 8px;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
    }

    @media screen and (max-width: 1200px) {
        .returno-top-contact {
            display: none;
        }
    }

    @media screen and (max-width: 900px) {
        .returno-top-banner {
            min-height: 34px;
            max-height: 34px;
            padding: 4px 6px;
            gap: 6px;
        }

        .returno-top-carousel {
            gap: 6px;
        }

        .returno-top-item-icon {
            width: 20px;
            height: 20px;
        }

        .returno-top-item-content {
            font-size: 10px;
        }

        .returno-top-item-content strong {
            font-size: 11px;
        }

        .returno-top-item-content a {
            display: none;
        }

        .returno-nav {
            width: 20px;
            height: 20px;
            font-size: 10px;
        }

        .returno-top-close {
            padding: 2px 7px;
            font-size: 10px;
        }
    }
</style>
